const reviews = [
  {
    stars: 5,
    headline: "Best CPR Class I've Ever Taken",
    text: "I trained with Destiny, and you can tell she's a real RN. She explained everything in a way that made sense in real-life situations. Hands-on practice was top-tier and I left feeling genuinely confident. Same-day certification made it even better.",
    name: "Maria G.",
    role: "Nursing Student",
    instructor: "Destiny",
    avatar: "https://public.readdy.ai/ai/img_res/9ffaada835f523ae9f0dbf4d3fe5dca5.jpg",
  },
  {
    stars: 5,
    headline: "Professional and Straight to the Point",
    text: "I had my class with Nathaniel, and he was extremely knowledgeable and patient. He made sure everyone understood proper technique and corrected us when needed. You can tell he actually works in the field.",
    name: "James T.",
    role: "EMT / First Responder",
    instructor: "Nathaniel",
    avatar: "https://readdy.ai/api/search-image?query=natural%20candid%20portrait%20Black%20man%20early%20thirties%20confident%20calm%20expression%20short%20fade%20haircut%20light%20beard%20casual%20button%20shirt%20soft%20neutral%20indoor%20background%20realistic%20photography&width=80&height=80&seq=rev-james-v3&orientation=squarish",
  },
  {
    stars: 5,
    headline: "Highly Recommend Cardiocraft CPR",
    text: "Destiny made the class engaging and easy to follow. I've taken CPR before, but this was the first time I actually felt confident doing compressions correctly. Definitely coming back for my renewal.",
    name: "Ashley R.",
    role: "ICU Nurse",
    instructor: "Destiny",
    avatar: "https://readdy.ai/api/search-image?query=natural%20candid%20portrait%20Black%20woman%20late%20twenties%20professional%20confident%20natural%20curly%20hair%20scrubs%20or%20professional%20top%20soft%20warm%20indoor%20lighting%20realistic%20photography%20healthcare%20worker&width=80&height=80&seq=rev-ashley-v3&orientation=squarish",
  },
];

export default function TestimonialsPreview() {
  return (
    <section className="py-24 bg-brand-purple-pale">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-brand-purple text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4">
            Student Stories
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-brand-black mb-4">
            What Our Students Say
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto" />
        </div>

        {/* Reviews */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {reviews.map((review) => (
            <div key={review.name} className="bg-white rounded-xl p-8 border border-gray-100 flex flex-col">
              <div className="flex gap-1 mb-3">
                {Array.from({ length: review.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-brand-gold text-lg" />
                ))}
              </div>
              {/* Trained with tag */}
              <span
                className="inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full mb-4 self-start whitespace-nowrap"
                style={{
                  background: "linear-gradient(135deg, rgba(107,70,193,0.10), rgba(212,175,55,0.07))",
                  border: "1px solid rgba(212,175,55,0.4)",
                  color: "#7c4ec4",
                }}
              >
                <i className="ri-nurse-line text-xs" style={{ color: "#c9a227" }} />
                Trained with {review.instructor}, RN
              </span>
              <h3 className="font-semibold text-brand-black text-base mb-3">{review.headline}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-1">{review.text}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-12 h-12 rounded-full object-cover object-top border-2 border-brand-gold shrink-0"
                />
                <div>
                  <p className="font-semibold text-brand-black text-sm">{review.name}</p>
                  <p className="text-gray-400 text-xs">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
